import { LIMPAR_HISTORICOS_RESERVAS } from '../types'

export default function limparHistoricosReservas() {
  return { type: LIMPAR_HISTORICOS_RESERVAS }
}
